import React from 'react';
import { useTranslations, useStyles } from "examsbook-react-sdk/custom-hooks";
import { getQuestionsStatus } from "examsbook-react-sdk/common";
import { CNavLink } from "../../common/Header/c/CHeader";
import { useSelector } from "react-redux";
import DescriptionIcon from '@material-ui/icons/Description';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import CancelIcon from '@material-ui/icons/Cancel';

/**
 * Quiz result
 * @param props
 * @returns {*}
 * @constructor
 */
function QuizResult(props) {
    const { results, quizId, quizData } = props;
    const user = useSelector(state => state.user);
    const t = useTranslations();
    const classes = useStyles(styles)();
    const language = user.language || 'en';
    return (
        <>
            <div className={classes.iBlock}>
                <div className={classes.resultScreenFirst}>
                    <div className={classes.headResultScreen}>
                        <h3>{t('SUMMARY_SECTION_ANSWERED')}</h3>
                        <p>{t('ANSWER_SAVED_SUCCESSFULLY')}</p>
                    </div>
                    <div className={classes.bodyResultScreen}>
                        <div className={classes.tableSection}>
                            <table>
                                <thead>
                                <tr>
                                    <th>{t('SECTION')}</th>
                                    <th>{t('NO_OF_QUESTIONS')}</th>
                                    <th>{t('ANSWERED')}</th>
                                    <th> {t('NOT_ANSWERED')}</th>
                                    {/*<th>{t('MARKED_FOR_REVIEW')}</th>*/}
                                    <th>{t('NOT_VISITED')}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    results.map((item, index) => {
                                        let questionsStatus = getQuestionsStatus(item.questions);
                                        return <tr key={index}>
                                            <td>{typeof item.section === "object" ? item.section[language] : item.section}</td>
                                            <td>{item.questions.length}</td>
                                            <td>{questionsStatus.answered}</td>
                                            <td>{questionsStatus.notAnswered}</td>
                                            {/*<td>{questionsStatus.marked}</td>*/}
                                            <td>{questionsStatus.notVisited}</td>
                                        </tr>;
                                    })
                                }

                                </tbody>
                            </table>
                        </div>
                        <div className={classes.continueButton}>
                            <CNavLink to="/my-app/tests">
                                {t('Try another quiz')}
                            </CNavLink>
                            <CNavLink to={"/my-app/tests/result/" + quizId}>
                                {t('Show Results')}
                            </CNavLink>
                        </div>
                    </div>
                </div>
            </div>


            <div className={classes.quizContainer}>
                <div className={classes.quizName}>
                    <h2>{quizData.name}</h2>
                    <p>{t('SUMMARY_SECTION_ANSWERED')}</p>
                </div>
                {
                    results.map((item, index) => {
                        let questionsStatus = getQuestionsStatus(item.questions);
                        return <div className={classes.quizAttemptedContainer} key={index}>
                            <h4>{typeof item.section === "object" ? item.section[language] : item.section}</h4>
                            <ul>
                                <li>
                                    <DescriptionIcon/>
                                    <h4>{t('NO_OF_QUESTIONS')}</h4>
                                    <span>{item.questions.length}</span>
                                </li>
                                <li>
                                    <DescriptionIcon/>
                                    <h4>{t('ANSWERED')}</h4>
                                    <span>{questionsStatus.answered}</span>
                                </li>
                                <li>
                                    <SkipNextIcon/>
                                    <h4>{t('SKIPPED')}</h4>
                                    <span>{questionsStatus.notAnswered}</span>
                                </li>
                                <li>
                                    <CancelIcon/>
                                    <h4>{t('NOT_VISITED')}</h4>
                                    <span>{questionsStatus.notVisited}</span>
                                </li>
                            </ul>
                        </div>;
                    })
                }
                <CNavLink to={"/my-app/tests/result/" + quizId}>
                    {t('Show Results')}
                </CNavLink>
            </div>
        </>

    );
}

const styles = theme => ({
    continueButton: {
        width: '100%',
        float: 'left',
        margin: '20px 0',
        borderTop: '1px solid #ccc',
        textAlign: 'center',
        padding: '20px 0 0',
        '@media (max-width:767px)': {
            float: 'none',
            textAlign: 'center',
            display: 'inline-block',
        },
        '& a': {
            margin: '1%',
            width: 'auto',
            float: 'none',
            fontSize: '14px',
            backgroundColor: '#00bfa5',
            color: '#fff',
            padding: '10px 20px',
            border: 0,
            borderRadius: 3,
            cursor: 'pointer',
            textDecoration: 'none',
            '&:last-child': {
                backgroundColor: '#2962ff'
            },
            '@media (max-width:767px)': {
                marginRight: 10,
                width: 'auto',
                fontSize: 12,
                color: '#fff',
                padding: '10px',
                border: 0,
                borderRadius: 3,
                cursor: 'pointer',
                textDecoration: 'none',
                float: 'none',
                textAlign: 'center',
                display: 'inline-block',
            }
        }
    },
    iBlock: {
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,.5)',
        zIndex: 9999,
        padding: 50,
        width: 'calc(100% - 100px)',
        height: 'calc(100% - 100px)',
        '@media (max-width: 767px)': {
            display: 'none'
        },
        '@media (max-width:991px)': {
            padding: '15px',
            width: 'calc(100% - 30px)',
            height: 'calc(100% - 30px)',
        },
    },
    resultScreenFirst: {
        width: '100%',
        float: 'left',
        backgroundColor: '#fff',
        padding: '20px 20px 10px',
        boxSizing: 'border-box',
        maxHeight: 'calc(100vh - 90px)'
    },
    headResultScreen: {
        width: '100%',
        float: 'left',
        textAlign: 'center',
        '& h3': {
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 15
        },
        '& p': {
            fontSize: 12,
            fontWeight: 400,
            marginTop: 0,
            color: '#777'
        }
    },
    bodyResultScreen: {
        width: '100%',
        float: 'left'
    },
    tableSection: {
        width: '100%',
        float: 'left',
        marginTop: 5,
        '& table': {
            width: '100%',
            borderSpacing: 'inherit',
            borderRight: '1px solid #ccc',

            '& th': {
                borderBottom: 0,
                fontSize: 14,
                backgroundColor: '#0039cb',
                color: '#fff',
                textAlign: 'center',
                padding: '10px 0',
                border: '1px solid #ccc',
                borderRight: 0
            },
            '& td': {
                fontSize: 13,
                textAlign: 'center',
                padding: '10px 0',
                border: '1px solid #ccc',
                borderRight: 0
            },
            '@media (max-width:767px)': {
                '& td': {
                    borderBottom: '1px solid #ddd',
                    padding: '5px 6px',
                    fontSize: '9px'
                },
                '& th': {
                    borderBottom: '1px solid #ddd',
                    padding: '5px 0',
                    fontSize: '9px'
                },
            },
        }
    },
    quizContainer: {
        display: 'none',
        '@media (max-width: 767px)': {
            display: 'block'
        },
        position: 'fixed',
        background: '#fff',
        zIndex: 9,
        left: 0,
        right: 0,
        padding: '20px 15px 60px',
        boxSizing: 'border-box',
        height: '100vh',
        top: 0,
        overflow: 'auto',
        '& a': {
            bottom: 10,
            position: 'fixed',
            left: 0,
            right: 0,
            margin: '0 15px',
            borderRadius: 4,
            color: '#fff',
            background: '#00BFA5',
            padding: '15px 20px',
            cursor: 'pointer',
            boxShadow: 'none',
            border: 'none',
            textDecoration: 'none',
            textAlign: 'center',
            display: 'block'
        }
    },
    quizName: {
        '& h2': {
            margin: 0,
            fontSize: 20,
            color: '#000',
            fontWeight: 'bold',
            paddingBottom: 10,
            textAlign: 'center'
        },
        '& p': {
            margin: 0,
            fontSize: 14,
            color: '#008E76',
            textAlign: 'center',
            fontWeight: 500
        }
    },
    quizAttemptedContainer: {
        marginTop: 30,
        borderBottom: '1px solid #eee',
        paddingBottom: 15,
        '& > h4': {
            opacity: 0.4,
            fontSize: 13,
            textTransform: 'uppercase',
            marginBottom: 20
        },
        '& ul': {
            listStyle: 'none',
            margin: 0,
            padding: 0,
            '& li': {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginBottom: 15,
                '& svg': {
                    color: '#00BFA5',
                    opacity: 0.5,
                    width: 26,
                    height: 26,
                    marginRight: 10
                },
                '& h4': {
                    margin: 0,
                    fontSize: 14,
                    color: '#000',
                    fontWeight: 600
                },
                '& span': {
                    fontSize: 14,
                    color: '#000',
                    fontWeight: 600,
                    display: 'flex',
                    marginLeft: 'auto'
                }
            }
        }
    }
});
export default QuizResult;
